// TODO: This file belongs in app, not common.

import { DialogType } from '@tableau/widgets';

import { AboutTableauServerDialog } from '../../app/header/AboutTableauServerDialog';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';
import { ServerService } from '../../ts/services/ServerService';
import { HelpService } from '../../commonInfra/services/HelpService';

export class HelpActions {

  constructor(
    private server: ServerService,
  ) {}

  public showAbout() {
    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      serverName: this.server.serverName(),
      version: this.server.sessionServerVersion(),
      podId: this.server.sessionServerPodId()
    };

    modalInstance = ReactModalService.open({
      type: DialogType.NormalWithTitleBar,
      title: AboutTableauServerDialog.Title(dialogProps),
      dialogContent: AboutTableauServerDialog.Content(dialogProps),
      footerContent: AboutTableauServerDialog.Footer(dialogProps),
      dialogWidth: 450
    });
  }

  public searchHelp(searchTerm: string) {
    HelpService.search(searchTerm);
  }

}
